/***
 * Created on 2023/7/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/


import React, {useState} from 'react';

function TableHeaderField({fieldName, sortable=false, sortDirection='asc', size=32, isAction=false, currentSortType, setCurrentSortType, setSortDirection}) {
    // const [sortType, setSortType] = useState(sortDirection);

    const toggleSortType = () => {
        let order;
        setSortDirection(prev => {
            if (prev === 'asc') {
                order = 'desc';
            }
            else {
                order = 'asc';
            }
            setCurrentSortType(fieldName)
            return order
        });
    }

    return (
        <div className={`flex-table__cell flex-table-header__cell w-${size} ${isAction ? 'flex-table__cell--action': ''}`}>
            {
                sortable && (
                    <div className="flex-table-header__cell__sort cursor-pointer" onClick={toggleSortType}>
                        <div className="cell__sort-label">{fieldName}</div>
                        {
                            fieldName === currentSortType &&
                            <div className={`cell__sort-arrow ${sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'}`} />
                        }
                    </div>
                )
            }
            {
                !sortable && fieldName
            }
        </div>
    );
}

export default TableHeaderField;